function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.2121 10.6308L22.3333 6.57019V28.4242L14.2121 24.3636V10.6308ZM11.7026 7.34566L26.3939 0V34.9944L11.7024 27.6487H4.0606C1.81799 27.6487 0 25.8307 0 23.5881V11.4063C0 9.16366 1.81799 7.34566 4.0606 7.34566H11.7026ZM10.1515 11.4063H4.06062V23.5881H10.1515V11.4063ZM37.9242 0.151805C42.0549 4.26118 44.6666 10.5295 44.6666 17.4972C44.6666 24.465 42.0549 30.7333 37.9242 34.8427L34.7245 32.2829C38.2686 28.9758 40.606 23.6129 40.606 17.4972C40.606 11.3816 38.2686 6.01864 34.7245 2.71153L37.9242 0.151805ZM36.5455 17.4972C36.5455 12.6028 34.6469 8.18295 31.6215 5.19397L28.4187 7.75618C30.8752 9.96825 32.4849 13.4887 32.4849 17.4972C32.4849 21.5057 30.8752 25.0261 28.4187 27.2382L31.6215 29.8004C34.6469 26.8114 36.5455 22.3916 36.5455 17.4972Z",
  fill: "white"
});

var SvgSoundOn = function SvgSoundOn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 35,
    viewBox: "0 0 45 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSoundOn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sound_on.d9a98f16.svg";
export { ForwardRef as ReactComponent };